import React, { Component } from "react";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import TextInputField from "../Form/TextInputField";
import { getVillaName } from "@my-dld/utils/PropertyUtils";
import { getUnitTypeAndSubType } from "@my-dld/screens/ExternalValuation";

interface Props {
	property: AssetCard,
}

interface State {
	area: string,
	municipalityNumber: string,
	villaName: string,
	uniType: string,
}

class VillaValuationForm extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			area: LocaleUtil.getLocalValue( this.props.property.area ),
			municipalityNumber: this.props.property.municipalityNo,
			villaName: getVillaName( this.props.property ),
			uniType: getUnitTypeAndSubType( this.props.property ),
		};
	}

	componentDidMount() {
	}

	render() {
		return <React.Fragment>
			<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
				<TextInputField
					id={ "area" }
					holder={ this }
					required={ false }
					label={ Strings.community }
					disabled={ true }
					containerClassName={ "form-group field-style mb-4" }
					inputClassName={ "form-control" }/>
			</div>
			<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
				<TextInputField
					id={ "municipalityNumber" }
					holder={ this }
					required={ false }
					label={ Strings.municipality_number }
					disabled={ true }
					containerClassName={ "form-group field-style mb-4" }
					inputClassName={ "form-control" }/>
			</div>
			<div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
				<TextInputField
					id={ "villaName" }
					holder={ this }
					required={ false }
					label={ Strings.villa_name }
					disabled={ true }
					containerClassName={ "form-group field-style mb-4" }
					inputClassName={ "form-control" }/>
			</div>
		</React.Fragment>;
	}
}

export default VillaValuationForm;
